"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPERMAX_CHEF = void 0;
const types_1 = require("../types");
exports.IMPERMAX_CHEF = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: '0x89703cA5c6C3BD35f9D288Ff9710BecBFA8C6f7b',
    [types_1.Networks.Arbitrum]: '0xcF16FF305eab2E44B568d3148E2EBBBfD48DB126',
    //[Networks.Arbitrum]: '0x99CF05461dd5F94761d4Fae6a2abDa47A93451f5',
    [types_1.Networks.Avalanche]: '0x5475aEd9d11BeaA822e122C36ACDfa0dA2eb086f',
    [types_1.Networks.Moonriver]: '0xD299D53Fc3B09038765af2091a0647e2304a7caa',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '0x19D8a5Abbd08E8Cf6aA9b2df46A04D13CCB7E3b4',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
